import styled from "@emotion/styled";
import { tokens } from "../../../design-system/tokens";

// Estilos del overlay que cubre toda la pantalla
export const LoadingOverlay = styled.div<{
  isVisible: boolean;
  $isModalOpen?: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: ${(props) => (props.isVisible ? "blur(5px)" : "blur(0px)")};
  background-color: rgba(0, 0, 0, ${(props) => (props.isVisible ? 0.5 : 0)});
  transition: backdrop-filter 0.3s ease, opacity 0.3s ease,
    background-color 0.3s ease;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};
  z-index: ${(props) => (props.$isModalOpen ? "4000" : tokens.zIndex.modal)};
  color: ${tokens.colors.basics[0]};
`;

// Contenedor del spinner
export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${tokens.spacing.lg};
  gap: ${tokens.spacing.md};
`;

// Spinner principal (ícono)
export const MainSpinner = styled.img`
  width: 80px;
  height: 80px;
`;

// Spinner Progreso
export const ProgressSpinner = styled.img`
  width: 200px;
  height: 10px;
`;

// Texto de carga
export const LoadingText = styled.div`
  font-size: ${tokens.typography.fontSize.md};
  color: ${tokens.colors.basics[0]};
  font-weight: ${tokens.typography.fontWeight.medium};
  font-family: ${tokens.typography.fontFamily.primary};
`;
